export default __webpack_public_path__ + "static/kathleen-bitmoji-5b3ba4c84bfbce48a0d82f361faa8988.png";